import { Box, Tab, styled } from "@mui/material";

export const RoleTab = styled(Tab)`
  margin-top: 8px;
  margin-right: 15px;
  border: none;
  height: 48px;
  background: #1c56ce 0% 0% no-repeat padding-box;
  border-radius: 4px 4px 0px 0px;
  opacity: 1;
  color: #fff;
  flex-grow: 1;
`
export const PermissionTableWrapper = styled(Box)({
  borderLeft: "0.5px solid #FFFFFF",
  flex: 4,
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  // alignItems: "center",
  // justifyContent: "center"
  // overflowY: "scroll"
})

export const PermissionTableHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  padding: "0px 10px",
  minHeight: "40px",
  borderLeft: "1px solid #FFFFFF",
  backgroundColor: "#3F68CF",
  color: "#FFFFFF"
})